import React, {useEffect, useState} from 'react';
import {FormControl, Grid, InputLabel, MenuItem} from "@mui/material";
import Select from "react-select";

function LocationSelectForMain({ setCity, setDistrict }) {
  // İllerin ve ilçelerin state olarak tanımlanması
const iller = [
    {
        "value": "1",
        "label": "ADANA"
    },
    {
        "value": "2",
        "label": "ADIYAMAN"
    },
    {
        "value": "3",
        "label": "AFYONKARAHİSAR"
    },
    {
        "value": "4",
        "label": "AĞRI"
    },
    {
        "value": "68",
        "label": "AKSARAY"
    },
    {
        "value": "5",
        "label": "AMASYA"
    },
    {
        "value": "6",
        "label": "ANKARA"
    },
    {
        "value": "7",
        "label": "ANTALYA"
    },
    {
        "value": "75",
        "label": "ARDAHAN"
    },
    {
        "value": "8",
        "label": "ARTVİN"
    },
    {
        "value": "9",
        "label": "AYDIN"
    },
    {
        "value": "10",
        "label": "BALIKESİR"
    },
    {
        "value": "74",
        "label": "BARTIN"
    },
    {
        "value": "72",
        "label": "BATMAN"
    },
    {
        "value": "69",
        "label": "BAYBURT"
    },
    {
        "value": "11",
        "label": "BİLECİK"
    },
    {
        "value": "12",
        "label": "BİNGÖL"
    },
    {
        "value": "13",
        "label": "BİTLİS"
    },
    {
        "value": "14",
        "label": "BOLU"
    },
    {
        "value": "15",
        "label": "BURDUR"
    },
    {
        "value": "16",
        "label": "BURSA"
    },
    {
        "value": "17",
        "label": "ÇANAKKALE"
    },
    {
        "value": "18",
        "label": "ÇANKIRI"
    },
    {
        "value": "19",
        "label": "ÇORUM"
    },
    {
        "value": "20",
        "label": "DENİZLİ"
    },
    {
        "value": "21",
        "label": "DİYARBAKIR"
    },
    {
        "value": "81",
        "label": "DÜZCE"
    },
    {
        "value": "22",
        "label": "EDİRNE"
    },
    {
        "value": "23",
        "label": "ELAZIĞ"
    },
    {
        "value": "24",
        "label": "ERZİNCAN"
    },
    {
        "value": "25",
        "label": "ERZURUM"
    },
    {
        "value": "26",
        "label": "ESKİŞEHİR"
    },
    {
        "value": "27",
        "label": "GAZİANTEP"
    },
    {
        "value": "28",
        "label": "GİRESUN"
    },
    {
        "value": "502",
        "label": "GİRNE (KIBRIS)"
    },
    {
        "value": "29",
        "label": "GÜMÜŞHANE"
    },
    {
        "value": "30",
        "label": "HAKKARİ"
    },
    {
        "value": "31",
        "label": "HATAY"
    },
    {
        "value": "76",
        "label": "IĞDIR"
    },
    {
        "value": "32",
        "label": "ISPARTA"
    },
    {
        "value": "34",
        "label": "İSTANBUL"
    },
    {
        "value": "35",
        "label": "İZMİR"
    },
    {
        "value": "46",
        "label": "KAHRAMANMARAŞ"
    },
    {
        "value": "78",
        "label": "KARABÜK"
    },
    {
        "value": "70",
        "label": "KARAMAN"
    },
    {
        "value": "36",
        "label": "KARS"
    },
    {
        "value": "37",
        "label": "KASTAMONU"
    },
    {
        "value": "38",
        "label": "KAYSERİ"
    },
    {
        "value": "71",
        "label": "KIRIKKALE"
    },
    {
        "value": "39",
        "label": "KIRKLARELİ"
    },
    {
        "value": "40",
        "label": "KIRŞEHİR"
    },
    {
        "value": "79",
        "label": "KİLİS"
    },
    {
        "value": "41",
        "label": "KOCAELİ"
    },
    {
        "value": "42",
        "label": "KONYA"
    },
    {
        "value": "43",
        "label": "KÜTAHYA"
    },
    {
        "value": "501",
        "label": "LEFKOŞE (KIBRIS)"
    },
    {
        "value": "503",
        "label": "MAĞUSA (KIBRIS)"
    },
    {
        "value": "44",
        "label": "MALATYA"
    },
    {
        "value": "45",
        "label": "MANİSA"
    },
    {
        "value": "47",
        "label": "MARDİN"
    },
    {
        "value": "33",
        "label": "MERSİN"
    },
    {
        "value": "48",
        "label": "MUĞLA"
    },
    {
        "value": "49",
        "label": "MUŞ"
    },
    {
        "value": "50",
        "label": "NEVŞEHİR"
    },
    {
        "value": "51",
        "label": "NİĞDE"
    },
    {
        "value": "52",
        "label": "ORDU"
    },
    {
        "value": "80",
        "label": "OSMANİYE"
    },
    {
        "value": "53",
        "label": "RİZE"
    },
    {
        "value": "54",
        "label": "SAKARYA"
    },
    {
        "value": "55",
        "label": "SAMSUN"
    },
    {
        "value": "56",
        "label": "SİİRT"
    },
    {
        "value": "57",
        "label": "SİNOP"
    },
    {
        "value": "58",
        "label": "SİVAS"
    },
    {
        "value": "63",
        "label": "ŞANLIURFA"
    },
    {
        "value": "73",
        "label": "ŞIRNAK"
    },
    {
        "value": "59",
        "label": "TEKİRDAĞ"
    },
    {
        "value": "60",
        "label": "TOKAT"
    },
    {
        "value": "61",
        "label": "TRABZON"
    },
    {
        "value": "62",
        "label": "TUNCELİ"
    },
    {
        "value": "64",
        "label": "UŞAK"
    },
    {
        "value": "65",
        "label": "VAN"
    },
    {
        "value": "77",
        "label": "YALOVA"
    },
    {
        "value": "66",
        "label": "YOZGAT"
    },
    {
        "value": "67",
        "label": "ZONGULDAK"
    }
]
    const turkishCharacterRegex = keyword => keyword
        .replace(/[ıİiI]/g, '[ıİiI]')
        .replace(/[şŞsS]/g, '[şŞsS]')
        .replace(/[çÇcC]/g, '[çÇcC]')
        .replace(/[ğĞgG]/g, '[ğĞgG]')
        .replace(/[öÖoO]/g, '[öÖoO]')
        .replace(/[üÜuU]/g, '[üÜuU]');

    const customFilter = (option, searchText) =>((turkishCharacterRegex(option.data.label)).toLowerCase().includes(turkishCharacterRegex(searchText).toLowerCase()));


   const [ills] = useState(iller);

  const [ilceler] = useState([
{"value":"1757","il_id":"1","label":"ALADAĞ"},
{"value":"1219","il_id":"1","label":"CEYHAN"},
{"value":"2033","il_id":"1","label":"ÇUKUROVA"},
{"value":"1329","il_id":"1","label":"FEKE"},
{"value":"1806","il_id":"1","label":"İMAMOĞLU"},
{"value":"1437","il_id":"1","label":"KARAİSALI"},
{"value":"1443","il_id":"1","label":"KARATAŞ"},
{"value":"1486","il_id":"1","label":"KOZAN"},
{"value":"1580","il_id":"1","label":"POZANTI"},
{"value":"1588","il_id":"1","label":"SAİMBEYLİ"},
{"value":"2032","il_id":"1","label":"SARIÇAM"},
{"value":"1104","il_id":"1","label":"SEYHAN"},
{"value":"1687","il_id":"1","label":"TUFANBEYLİ"},
{"value":"1734","il_id":"1","label":"YUMURTALIK"},
{"value":"1748","il_id":"1","label":"YÜREĞİR"},
{"value":"1182","il_id":"2","label":"BESNİ"},
{"value":"1246","il_id":"2","label":"ÇELİKHAN"},
{"value":"1347","il_id":"2","label":"GERGER"},
{"value":"1354","il_id":"2","label":"GÖLBAŞI"},
{"value":"1425","il_id":"2","label":"KAHTA"},
{"value":"1105","il_id":"2","label":"MERKEZ"},
{"value":"1592","il_id":"2","label":"SAMSAT"},
{"value":"1985","il_id":"2","label":"SİNCİK"},
{"value":"1989","il_id":"2","label":"TUT"},
{"value":"1771","il_id":"3","label":"BAŞMAKÇI"},
{"value":"1773","il_id":"3","label":"BAYAT"},
{"value":"1200","il_id":"3","label":"BOLVADİN"},
{"value":"1239","il_id":"3","label":"ÇAY"},
{"value":"1906","il_id":"3","label":"ÇOBANLAR"},
{"value":"1267","il_id":"3","label":"DAZKIRI"},
{"value":"1281","il_id":"3","label":"DİNAR"},
{"value":"1306","il_id":"3","label":"EMİRDAĞ"},
{"value":"1923","il_id":"3","label":"EVCİLER"},
{"value":"1944","il_id":"3","label":"HOCALAR"},
{"value":"1404","il_id":"3","label":"İHSANİYE"},
{"value":"1809","il_id":"3","label":"İSCEHİSAR"},
{"value":"1961","il_id":"3","label":"KIZILÖREN"},
{"value":"1108","il_id":"3","label":"MERKEZ"},
{"value":"1594","il_id":"3","label":"SANDIKLI"},
{"value":"1626","il_id":"3","label":"SİNANPAŞA"},
{"value":"1639","il_id":"3","label":"SULTANDAĞI"},
{"value":"1664","il_id":"3","label":"ŞUHUT"},
{"value":"1283","il_id":"4","label":"DİYADİN"},
{"value":"1287","il_id":"4","label":"DOĞUBAYAZIT"},
{"value":"1301","il_id":"4","label":"ELEŞKİRT"},
{"value":"1379","il_id":"4","label":"HAMUR"},
{"value":"1111","il_id":"4","label":"MERKEZ"},
{"value":"1568","il_id":"4","label":"PATNOS"},
{"value":"1667","il_id":"4","label":"TAŞLIÇAY"},
{"value":"1691","il_id":"4","label":"TUTAK"},
{"value":"1363","il_id":"5","label":"GÖYNÜCEK"},
{"value":"1368","il_id":"5","label":"GÜMÜŞHACIKÖY"},
{"value":"1938","il_id":"5","label":"HAMAMÖZÜ"},
{"value":"1134","il_id":"5","label":"MERKEZ"},
{"value":"1524","il_id":"5","label":"MERZİFON"},
{"value":"1641","il_id":"5","label":"SULUOVA"},
{"value":"1668","il_id":"5","label":"TAŞOVA"},
{"value":"1872","il_id":"6","label":"AKYURT"},
{"value":"1130","il_id":"6","label":"ALTINDAĞ"},
{"value":"1157","il_id":"6","label":"AYAŞ"},
{"value":"1167","il_id":"6","label":"BALA"},
{"value":"1187","il_id":"6","label":"BEYPAZARI"},
{"value":"1227","il_id":"6","label":"ÇAMLIDERE"},
{"value":"1231","il_id":"6","label":"ÇANKAYA"},
{"value":"1260","il_id":"6","label":"ÇUBUK"},
{"value":"1302","il_id":"6","label":"ELMADAĞ"},
{"value":"1922","il_id":"6","label":"ETİMESGUT"},
{"value":"1924","il_id":"6","label":"EVREN"},
{"value":"1744","il_id":"6","label":"GÖLBAŞI"},
{"value":"1365","il_id":"6","label":"GÜDÜL"},
{"value":"1387","il_id":"6","label":"HAYMANA"},
{"value":"1815","il_id":"6","label":"KAHRAMANKAZAN"},
{"value":"1427","il_id":"6","label":"KALECİK"},
{"value":"1745","il_id":"6","label":"KEÇİÖREN"},
{"value":"1473","il_id":"6","label":"KIZILCAHAMAM"},
{"value":"1746","il_id":"6","label":"MAMAK"},
{"value":"1539","il_id":"6","label":"NALLIHAN"},
{"value":"1578","il_id":"6","label":"POLATLI"},
{"value":"2034","il_id":"6","label":"PURSAKLAR"},
{"value":"1747","il_id":"6","label":"SİNCAN"},
{"value":"1658","il_id":"6","label":"ŞEREFLİKOÇHİSAR"},
{"value":"1723","il_id":"6","label":"YENİMAHALLE"},
{"value":"1121","il_id":"7","label":"AKSEKİ"},
{"value":"2035","il_id":"7","label":"AKSU"},
{"value":"1126","il_id":"7","label":"ALANYA"},
{"value":"1811","il_id":"7","label":"DEMRE"},
{"value":"2036","il_id":"7","label":"DÖŞEMEALTI"},
{"value":"1303","il_id":"7","label":"ELMALI"},
{"value":"1333","il_id":"7","label":"FİNİKE"},
{"value":"1337","il_id":"7","label":"GAZİPAŞA"},
{"value":"1370","il_id":"7","label":"GÜNDOĞMUŞ"},
{"value":"1946","il_id":"7","label":"İBRADI"},
{"value":"1451","il_id":"7","label":"KAŞ"},
{"value":"1959","il_id":"7","label":"KEMER"},
{"value":"2037","il_id":"7","label":"KEPEZ"},
{"value":"2038","il_id":"7","label":"KONYAALTI"},
{"value":"1483","il_id":"7","label":"KORKUTELİ"},
{"value":"1492","il_id":"7","label":"KUMLUCA"},
{"value":"1512","il_id":"7","label":"MANAVGAT"},
{"value":"2039","il_id":"7","label":"MURATPAŞA"},
{"value":"1616","il_id":"7","label":"SERİK"},
{"value":"1145","il_id":"8","label":"ARDANUÇ"},
{"value":"1147","il_id":"8","label":"ARHAVİ"},
{"value":"1202","il_id":"8","label":"BORÇKA"},
{"value":"1395","il_id":"8","label":"HOPA"},
{"value":"2105","il_id":"8","label":"KEMALPAŞA"},
{"value":"1152","il_id":"8","label":"MERKEZ"},
{"value":"1828","il_id":"8","label":"MURGUL"},
{"value":"1653","il_id":"8","label":"ŞAVŞAT"},
{"value":"1736","il_id":"8","label":"YUSUFELİ"},
{"value":"1206","il_id":"9","label":"BOZDOĞAN"},
{"value":"1781","il_id":"9","label":"BUHARKENT"},
{"value":"1256","il_id":"9","label":"ÇİNE"},
{"value":"2000","il_id":"9","label":"DİDİM"},
{"value":"2076","il_id":"9","label":"EFELER"},
{"value":"1348","il_id":"9","label":"GERMENCİK"},
{"value":"1807","il_id":"9","label":"İNCİRLİOVA"},
{"value":"1435","il_id":"9","label":"KARACASU"},
{"value":"1957","il_id":"9","label":"KARPUZLU"},
{"value":"1479","il_id":"9","label":"KOÇARLI"},
{"value":"1968","il_id":"9","label":"KÖŞK"},
{"value":"1497","il_id":"9","label":"KUŞADASI"},
{"value":"1498","il_id":"9","label":"KUYUCAK"},
{"value":"1542","il_id":"9","label":"NAZİLLİ"},
{"value":"1637","il_id":"9","label":"SÖKE"},
{"value":"1640","il_id":"9","label":"SULTANHİSAR"},
{"value":"1724","il_id":"9","label":"YENİPAZAR"},
{"value":"2077","il_id":"10","label":"ALTIEYLÜL"},
{"value":"1161","il_id":"10","label":"AYVALIK"},
{"value":"1169","il_id":"10","label":"BALYA"},
{"value":"1171","il_id":"10","label":"BANDIRMA"},
{"value":"1191","il_id":"10","label":"BİGADİÇ"},
{"value":"1216","il_id":"10","label":"BURHANİYE"},
{"value":"1291","il_id":"10","label":"DURSUNBEY"},
{"value":"1294","il_id":"10","label":"EDREMİT"},
{"value":"1310","il_id":"10","label":"ERDEK"},
{"value":"1928","il_id":"10","label":"GÖMEÇ"},
{"value":"1360","il_id":"10","label":"GÖNEN"},
{"value":"1384","il_id":"10","label":"HAVRAN"},
{"value":"1418","il_id":"10","label":"İVRİNDİ"},
{"value":"2078","il_id":"10","label":"KARESİ"},
{"value":"1462","il_id":"10","label":"KEPSUT"},
{"value":"1514","il_id":"10","label":"MANYAS"},
{"value":"1824","il_id":"10","label":"MARMARA"},
{"value":"1608","il_id":"10","label":"SAVAŞTEPE"},
{"value":"1619","il_id":"10","label":"SINDIRGI"},
{"value":"1644","il_id":"10","label":"SUSURLUK"},
{"value":"1210","il_id":"11","label":"BOZÜYÜK"},
{"value":"1359","il_id":"11","label":"GÖLPAZARI"},
{"value":"1948","il_id":"11","label":"İNHİSAR"},
{"value":"1192","il_id":"11","label":"MERKEZ"},
{"value":"1559","il_id":"11","label":"OSMANELİ"},
{"value":"1571","il_id":"11","label":"PAZARYERİ"},
{"value":"1636","il_id":"11","label":"SÖĞÜT"},
{"value":"1857","il_id":"11","label":"YENİPAZAR"},
{"value":"1750","il_id":"12","label":"ADAKLI"},
{"value":"1344","il_id":"12","label":"GENÇ"},
{"value":"1446","il_id":"12","label":"KARLIOVA"},
{"value":"1475","il_id":"12","label":"KİĞI"},
{"value":"1193","il_id":"12","label":"MERKEZ"},
{"value":"1633","il_id":"12","label":"SOLHAN"},
{"value":"1855","il_id":"12","label":"YAYLADERE"},
{"value":"1996","il_id":"12","label":"YEDİSU"},
{"value":"1106","il_id":"13","label":"ADİLCEVAZ"},
{"value":"1112","il_id":"13","label":"AHLAT"},
{"value":"1798","il_id":"13","label":"GÜROYMAK"},
{"value":"1394","il_id":"13","label":"HİZAN"},
{"value":"1196","il_id":"13","label":"MERKEZ"},
{"value":"1537","il_id":"13","label":"MUTKİ"},
{"value":"1669","il_id":"13","label":"TATVAN"},
{"value":"1916","il_id":"14","label":"DÖRTDİVAN"},
{"value":"1346","il_id":"14","label":"GEREDE"},
{"value":"1364","il_id":"14","label":"GÖYNÜK"},
{"value":"1466","il_id":"14","label":"KIBRISCIK"},
{"value":"1522","il_id":"14","label":"MENGEN"},
{"value":"1199","il_id":"14","label":"MERKEZ"},
{"value":"1531","il_id":"14","label":"MUDURNU"},
{"value":"1610","il_id":"14","label":"SEBEN"},
{"value":"1997","il_id":"14","label":"YENİÇAĞA"},
{"value":"1109","il_id":"15","label":"AĞLASUN"},
{"value":"1874","il_id":"15","label":"ALTINYAYLA"},
{"value":"1211","il_id":"15","label":"BUCAK"},
{"value":"1899","il_id":"15","label":"ÇAVDIR"},
{"value":"1903","il_id":"15","label":"ÇELTİKÇİ"},
{"value":"1357","il_id":"15","label":"GÖLHİSAR"},
{"value":"1813","il_id":"15","label":"KARAMANLI"},
{"value":"1816","il_id":"15","label":"KEMER"},
{"value":"1215","il_id":"15","label":"MERKEZ"},
{"value":"1672","il_id":"15","label":"TEFENNİ"},
{"value":"1728","il_id":"15","label":"YEŞİLOVA"},
{"value":"1783","il_id":"16","label":"BÜYÜKORHAN"},
{"value":"1343","il_id":"16","label":"GEMLİK"},
{"value":"1935","il_id":"16","label":"GÜRSU"},
{"value":"1799","il_id":"16","label":"HARMANCIK"},
{"value":"1411","il_id":"16","label":"İNEGÖL"},
{"value":"1420","il_id":"16","label":"İZNİK"},
{"value":"1434","il_id":"16","label":"KARACABEY"},
{"value":"1457","il_id":"16","label":"KELES"},
{"value":"1960","il_id":"16","label":"KESTEL"},
{"value":"1530","il_id":"16","label":"MUDANYA"},
{"value":"1535","il_id":"16","label":"MUSTAFAKEMALPAŞA"},
{"value":"1829","il_id":"16","label":"NİLÜFER"},
{"value":"1553","il_id":"16","label":"ORHANELİ"},
{"value":"1554","il_id":"16","label":"ORHANGAZİ"},
{"value":"1832","il_id":"16","label":"OSMANGAZİ"},
{"value":"1725","il_id":"16","label":"YENİŞEHİR"},
{"value":"1859","il_id":"16","label":"YILDIRIM"},
{"value":"1160","il_id":"17","label":"AYVACIK"},
{"value":"1180","il_id":"17","label":"BAYRAMİÇ"},
{"value":"1190","il_id":"17","label":"BİGA"},
{"value":"1205","il_id":"17","label":"BOZCAADA"},
{"value":"1229","il_id":"17","label":"ÇAN"},
{"value":"1293","il_id":"17","label":"ECEABAT"},
{"value":"1326","il_id":"17","label":"EZİNE"},
{"value":"1340","il_id":"17","label":"GELİBOLU"},
{"value":"1408","il_id":"17","label":"GÖKÇEADA"},
{"value":"1503","il_id":"17","label":"LAPSEKİ"},
{"value":"1230","il_id":"17","label":"MERKEZ"},
{"value":"1722","il_id":"17","label":"YENİCE"},
{"value":"1765","il_id":"18","label":"ATKARACALAR"},
{"value":"1885","il_id":"18","label":"BAYRAMÖREN"},
{"value":"1248","il_id":"18","label":"ÇERKEŞ"},
{"value":"1300","il_id":"18","label":"ELDİVAN"},
{"value":"1399","il_id":"18","label":"ILGAZ"},
{"value":"1817","il_id":"18","label":"KIZILIRMAK"},
{"value":"1963","il_id":"18","label":"KORGUN"},
{"value":"1494","il_id":"18","label":"KURŞUNLU"},
{"value":"1232","il_id":"18","label":"MERKEZ"},
{"value":"1555","il_id":"18","label":"ORTA"},
{"value":"1649","il_id":"18","label":"ŞABANÖZÜ"},
{"value":"1718","il_id":"18","label":"YAPRAKLI"},
{"value":"1124","il_id":"19","label":"ALACA"},
{"value":"1177","il_id":"19","label":"BAYAT"},
{"value":"1778","il_id":"19","label":"BOĞAZKALE"},
{"value":"1911","il_id":"19","label":"DODURGA"},
{"value":"1414","il_id":"19","label":"İSKİLİP"},
{"value":"1445","il_id":"19","label":"KARGI"},
{"value":"1972","il_id":"19","label":"LAÇİN"},
{"value":"1520","il_id":"19","label":"MECİTÖZÜ"},
{"value":"1259","il_id":"19","label":"MERKEZ"},
{"value":"1976","il_id":"19","label":"OĞUZLAR"},
{"value":"1556","il_id":"19","label":"ORTAKÖY"},
{"value":"1558","il_id":"19","label":"OSMANCIK"},
{"value":"1642","il_id":"19","label":"SUNGURLU"},
{"value":"1850","il_id":"19","label":"UĞURLUDAĞ"},
{"value":"1102","il_id":"20","label":"ACIPAYAM"},
{"value":"1769","il_id":"20","label":"BABADAĞ"},
{"value":"1881","il_id":"20","label":"BAKLAN"},
{"value":"1774","il_id":"20","label":"BEKİLLİ"},
{"value":"1888","il_id":"20","label":"BEYAĞAÇ"},
{"value":"1889","il_id":"20","label":"BOZKURT"},
{"value":"1214","il_id":"20","label":"BULDAN"},
{"value":"1224","il_id":"20","label":"ÇAL"},
{"value":"1226","il_id":"20","label":"ÇAMELİ"},
{"value":"1233","il_id":"20","label":"ÇARDAK"},
{"value":"1257","il_id":"20","label":"ÇİVRİL"},
{"value":"1371","il_id":"20","label":"GÜNEY"},
{"value":"1803","il_id":"20","label":"HONAZ"},
{"value":"1426","il_id":"20","label":"KALE"},
{"value":"2079","il_id":"20","label":"MERKEZEFENDİ"},
{"value":"1871","il_id":"20","label":"PAMUKKALE"},
{"value":"1597","il_id":"20","label":"SARAYKÖY"},
{"value":"1840","il_id":"20","label":"SERİNHİSAR"},
{"value":"1670","il_id":"20","label":"TAVAS"},
{"value":"2040","il_id":"21","label":"BAĞLAR"},
{"value":"1195","il_id":"21","label":"BİSMİL"},
{"value":"1249","il_id":"21","label":"ÇERMİK"},
{"value":"1253","il_id":"21","label":"ÇINAR"},
{"value":"1263","il_id":"21","label":"ÇÜNGÜŞ"},
{"value":"1278","il_id":"21","label":"DİCLE"},
{"value":"1791","il_id":"21","label":"EĞİL"},
{"value":"1315","il_id":"21","label":"ERGANİ"},
{"value":"1381","il_id":"21","label":"HANİ"},
{"value":"1389","il_id":"21","label":"HAZRO"},
{"value":"2041","il_id":"21","label":"KAYAPINAR"},
{"value":"1962","il_id":"21","label":"KOCAKÖY"},
{"value":"1490","il_id":"21","label":"KULP"},
{"value":"1504","il_id":"21","label":"LİCE"},
{"value":"1624","il_id":"21","label":"SİLVAN"},
{"value":"2042","il_id":"21","label":"SUR"},
{"value":"2043","il_id":"21","label":"YENİŞEHİR"},
{"value":"1307","il_id":"22","label":"ENEZ"},
{"value":"1385","il_id":"22","label":"HAVSA"},
{"value":"1412","il_id":"22","label":"İPSALA"},
{"value":"1464","il_id":"22","label":"KEŞAN"},
{"value":"1502","il_id":"22","label":"LALAPAŞA"},
{"value":"1523","il_id":"22","label":"MERİÇ"},
{"value":"1295","il_id":"22","label":"MERKEZ"},
{"value":"1988","il_id":"22","label":"SÜLOĞLU"},
{"value":"1705","il_id":"22","label":"UZUNKÖPRÜ"},
{"value":"1110","il_id":"23","label":"AĞIN"},
{"value":"1873","il_id":"23","label":"ALACAKAYA"},
{"value":"1762","il_id":"23","label":"ARICAK"},
{"value":"1173","il_id":"23","label":"BASKİL"},
{"value":"1438","il_id":"23","label":"KARAKOÇAN"},
{"value":"1455","il_id":"23","label":"KEBAN"},
{"value":"1820","il_id":"23","label":"KOVANCILAR"},
{"value":"1506","il_id":"23","label":"MADEN"},
{"value":"1298","il_id":"23","label":"MERKEZ"},
{"value":"1566","il_id":"23","label":"PALU"},
{"value":"1631","il_id":"23","label":"SİVRİCE"},
{"value":"1243","il_id":"24","label":"ÇAYIRLI"},
{"value":"1406","il_id":"24","label":"İLİÇ"},
{"value":"1459","il_id":"24","label":"KEMAH"},
{"value":"1460","il_id":"24","label":"KEMALİYE"},
{"value":"1318","il_id":"24","label":"MERKEZ"},
{"value":"1977","il_id":"24","label":"OTLUKBELİ"},
{"value":"1583","il_id":"24","label":"REFAHİYE"},
{"value":"1675","il_id":"24","label":"TERCAN"},
{"value":"1853","il_id":"24","label":"ÜZÜMLÜ"},
{"value":"1153","il_id":"25","label":"AŞKALE"},
{"value":"1945","il_id":"25","label":"AZİZİYE"},
{"value":"1235","il_id":"25","label":"ÇAT"},
{"value":"1392","il_id":"25","label":"HINIS"},
{"value":"1396","il_id":"25","label":"HORASAN"},
{"value":"1416","il_id":"25","label":"İSPİR"},
{"value":"1812","il_id":"25","label":"KARAÇOBAN"},
{"value":"1444","il_id":"25","label":"KARAYAZI"},
{"value":"1967","il_id":"25","label":"KÖPRÜKÖY"},
{"value":"1540","il_id":"25","label":"NARMAN"},
{"value":"1550","il_id":"25","label":"OLTU"},
{"value":"1551","il_id":"25","label":"OLUR"},
{"value":"2044","il_id":"25","label":"PALANDÖKEN"},
{"value":"1567","il_id":"25","label":"PASİNLER"},
{"value":"1865","il_id":"25","label":"PAZARYOLU"},
{"value":"1657","il_id":"25","label":"ŞENKAYA"},
{"value":"1674","il_id":"25","label":"TEKMAN"},
{"value":"1683","il_id":"25","label":"TORTUM"},
{"value":"1851","il_id":"25","label":"UZUNDERE"},
{"value":"2045","il_id":"25","label":"YAKUTİYE"},
{"value":"1759","il_id":"26","label":"ALPU"},
{"value":"1777","il_id":"26","label":"BEYLİKOVA"},
{"value":"1255","il_id":"26","label":"ÇİFTELER"},
{"value":"1934","il_id":"26","label":"GÜNYÜZÜ"},
{"value":"1939","il_id":"26","label":"HAN"},
{"value":"1808","il_id":"26","label":"İNÖNÜ"},
{"value":"1508","il_id":"26","label":"MAHMUDİYE"},
{"value":"1973","il_id":"26","label":"MİHALGAZİ"},
{"value":"1527","il_id":"26","label":"MİHALIÇÇIK"},
{"value":"2046","il_id":"26","label":"ODUNPAZARI"},
{"value":"1599","il_id":"26","label":"SARICAKAYA"},
{"value":"1618","il_id":"26","label":"SEYİTGAZİ"},
{"value":"1632","il_id":"26","label":"SİVRİHİSAR"},
{"value":"2047","il_id":"26","label":"TEPEBAŞI"},
{"value":"1139","il_id":"27","label":"ARABAN"},
{"value":"1415","il_id":"27","label":"İSLAHİYE"},
{"value":"1956","il_id":"27","label":"KARKAMIŞ"},
{"value":"1546","il_id":"27","label":"NİZİP"},
{"value":"1974","il_id":"27","label":"NURDAĞI"},
{"value":"1549","il_id":"27","label":"OĞUZELİ"},
{"value":"1841","il_id":"27","label":"ŞAHİNBEY"},
{"value":"1844","il_id":"27","label":"ŞEHİTKAMİL"},
{"value":"1720","il_id":"27","label":"YAVUZELİ"},
{"value":"1133","il_id":"28","label":"ALUCRA"},
{"value":"1212","il_id":"28","label":"BULANCAK"},
{"value":"1893","il_id":"28","label":"ÇAMOLUK"},
{"value":"1894","il_id":"28","label":"ÇANAKÇI"},
{"value":"1272","il_id":"28","label":"DERELİ"},
{"value":"1912","il_id":"28","label":"DOĞANKENT"},
{"value":"1320","il_id":"28","label":"ESPİYE"},
{"value":"1324","il_id":"28","label":"EYNESİL"},
{"value":"1361","il_id":"28","label":"GÖRELE"},
{"value":"1930","il_id":"28","label":"GÜCE"},
{"value":"1465","il_id":"28","label":"KEŞAP"},
{"value":"1352","il_id":"28","label":"MERKEZ"},
{"value":"1837","il_id":"28","label":"PİRAZİZ"},
{"value":"1654","il_id":"28","label":"ŞEBİNKARAHİSAR"},
{"value":"1678","il_id":"28","label":"TİREBOLU"},
{"value":"1854","il_id":"28","label":"YAĞLIDERE"},
{"value":"1458","il_id":"29","label":"KELKİT"},
{"value":"1822","il_id":"29","label":"KÖSE"},
{"value":"1971","il_id":"29","label":"KÜRTÜN"},
{"value":"1369","il_id":"29","label":"MERKEZ"},
{"value":"1660","il_id":"29","label":"ŞİRAN"},
{"value":"1684","il_id":"29","label":"TORUL"},
{"value":"1261","il_id":"30","label":"ÇUKURCA"},
{"value":"2107","il_id":"30","label":"DERECİK"},
{"value":"1377","il_id":"30","label":"MERKEZ"},
{"value":"1656","il_id":"30","label":"ŞEMDİNLİ"},
{"value":"1737","il_id":"30","label":"YÜKSEKOVA"},
{"value":"1131","il_id":"31","label":"ALTINÖZÜ"},
{"value":"2080","il_id":"31","label":"ANTAKYA"},
{"value":"2081","il_id":"31","label":"ARSUZ"},
{"value":"1887","il_id":"31","label":"BELEN"},
{"value":"2082","il_id":"31","label":"DEFNE"},
{"value":"1289","il_id":"31","label":"DÖRTYOL"},
{"value":"1792","il_id":"31","label":"ERZİN"},
{"value":"1382","il_id":"31","label":"HASSA"},
{"value":"1413","il_id":"31","label":"İSKENDERUN"},
{"value":"1468","il_id":"31","label":"KIRIKHAN"},
{"value":"1970","il_id":"31","label":"KUMLU"},
{"value":"2083","il_id":"31","label":"PAYAS"},
{"value":"1585","il_id":"31","label":"REYHANLI"},
{"value":"1591","il_id":"31","label":"SAMANDAĞ"},
{"value":"1721","il_id":"31","label":"YAYLADAĞI"},
{"value":"1755","il_id":"32","label":"AKSU"},
{"value":"1154","il_id":"32","label":"ATABEY"},
{"value":"1297","il_id":"32","label":"EĞİRDİR"},
{"value":"1341","il_id":"32","label":"GELENDOST"},
{"value":"1929","il_id":"32","label":"GÖNEN"},
{"value":"1456","il_id":"32","label":"KEÇİBORLU"},
{"value":"1401","il_id":"32","label":"MERKEZ"},
{"value":"1615","il_id":"32","label":"SENİRKENT"},
{"value":"1648","il_id":"32","label":"SÜTÇÜLER"},
{"value":"1651","il_id":"32","label":"ŞARKİKARAAĞAÇ"},
{"value":"1699","il_id":"32","label":"ULUBORLU"},
{"value":"1717","il_id":"32","label":"YALVAÇ"},
{"value":"2001","il_id":"32","label":"YENİŞARBADEMLİ"},
{"value":"2064","il_id":"33","label":"AKDENİZ"},
{"value":"1135","il_id":"33","label":"ANAMUR"},
{"value":"1766","il_id":"33","label":"AYDINCIK"},
{"value":"1779","il_id":"33","label":"BOZYAZI"},
{"value":"1892","il_id":"33","label":"ÇAMLIYAYLA"},
{"value":"1311","il_id":"33","label":"ERDEMLİ"},
{"value":"1366","il_id":"33","label":"GÜLNAR"},
{"value":"2065","il_id":"33","label":"MEZİTLİ"},
{"value":"1536","il_id":"33","label":"MUT"},
{"value":"1621","il_id":"33","label":"SİLİFKE"},
{"value":"1665","il_id":"33","label":"TARSUS"},
{"value":"2066","il_id":"33","label":"TOROSLAR"},
{"value":"2067","il_id":"33","label":"YENİŞEHİR"},
{"value":"1103","il_id":"34","label":"ADALAR"},
{"value":"2048","il_id":"34","label":"ARNAVUTKÖY"},
{"value":"2049","il_id":"34","label":"ATAŞEHİR"},
{"value":"2003","il_id":"34","label":"AVCILAR"},
{"value":"2004","il_id":"34","label":"BAĞCILAR"},
{"value":"2005","il_id":"34","label":"BAHÇELİEVLER"},
{"value":"1166","il_id":"34","label":"BAKIRKÖY"},
{"value":"2050","il_id":"34","label":"BAŞAKŞEHİR"},
{"value":"1886","il_id":"34","label":"BAYRAMPAŞA"},
{"value":"1183","il_id":"34","label":"BEŞİKTAŞ"},
{"value":"1185","il_id":"34","label":"BEYKOZ"},
{"value":"2051","il_id":"34","label":"BEYLİKDÜZÜ"},
{"value":"1186","il_id":"34","label":"BEYOĞLU"},
{"value":"1782","il_id":"34","label":"BÜYÜKÇEKMECE"},
{"value":"1237","il_id":"34","label":"ÇATALCA"},
{"value":"2052","il_id":"34","label":"ÇEKMEKÖY"},
{"value":"2016","il_id":"34","label":"ESENLER"},
{"value":"2053","il_id":"34","label":"ESENYURT"},
{"value":"1325","il_id":"34","label":"EYÜPSULTAN"},
{"value":"1327","il_id":"34","label":"FATİH"},
{"value":"1336","il_id":"34","label":"GAZİOSMANPAŞA"},
{"value":"2010","il_id":"34","label":"GÜNGÖREN"},
{"value":"1421","il_id":"34","label":"KADIKÖY"},
{"value":"1810","il_id":"34","label":"KAĞITHANE"},
{"value":"1449","il_id":"34","label":"KARTAL"},
{"value":"1823","il_id":"34","label":"KÜÇÜKÇEKMECE"},
{"value":"2012","il_id":"34","label":"MALTEPE"},
{"value":"1835","il_id":"34","label":"PENDİK"},
{"value":"2054","il_id":"34","label":"SANCAKTEPE"},
{"value":"1604","il_id":"34","label":"SARIYER"},
{"value":"1622","il_id":"34","label":"SİLİVRİ"},
{"value":"2014","il_id":"34","label":"SULTANBEYLİ"},
{"value":"2055","il_id":"34","label":"SULTANGAZİ"},
{"value":"1659","il_id":"34","label":"ŞİLE"},
{"value":"1663","il_id":"34","label":"ŞİŞLİ"},
{"value":"2015","il_id":"34","label":"TUZLA"},
{"value":"1852","il_id":"34","label":"ÜMRANİYE"},
{"value":"1708","il_id":"34","label":"ÜSKÜDAR"},
{"value":"1739","il_id":"34","label":"ZEYTİNBURNU"},
{"value":"1128","il_id":"35","label":"ALİAĞA"},
{"value":"2006","il_id":"35","label":"BALÇOVA"},
{"value":"1178","il_id":"35","label":"BAYINDIR"},
{"value":"2056","il_id":"35","label":"BAYRAKLI"},
{"value":"1181","il_id":"35","label":"BERGAMA"},
{"value":"1776","il_id":"35","label":"BEYDAĞ"},
{"value":"1203","il_id":"35","label":"BORNOVA"},
{"value":"1780","il_id":"35","label":"BUCA"},
{"value":"1251","il_id":"35","label":"ÇEŞME"},
{"value":"2007","il_id":"35","label":"ÇİĞLİ"},
{"value":"1280","il_id":"35","label":"DİKİLİ"},
{"value":"1334","il_id":"35","label":"FOÇA"},
{"value":"2009","il_id":"35","label":"GAZİEMİR"},
{"value":"2018","il_id":"35","label":"GÜZELBAHÇE"},
{"value":"2057","il_id":"35","label":"KARABAĞLAR"},
{"value":"1432","il_id":"35","label":"KARABURUN"},
{"value":"1448","il_id":"35","label":"KARŞIYAKA"},
{"value":"1461","il_id":"35","label":"KEMALPAŞA"},
{"value":"1467","il_id":"35","label":"KINIK"},
{"value":"1477","il_id":"35","label":"KİRAZ"},
{"value":"1819","il_id":"35","label":"KONAK"},
{"value":"1826","il_id":"35","label":"MENDERES"},
{"value":"1521","il_id":"35","label":"MENEMEN"},
{"value":"2013","il_id":"35","label":"NARLIDERE"},
{"value":"1563","il_id":"35","label":"ÖDEMİŞ"},
{"value":"1611","il_id":"35","label":"SEFERİHİSAR"},
{"value":"1612","il_id":"35","label":"SELÇUK"},
{"value":"1677","il_id":"35","label":"TİRE"},
{"value":"1682","il_id":"35","label":"TORBALI"},
{"value":"1703","il_id":"35","label":"URLA"},
{"value":"1756","il_id":"36","label":"AKYAKA"},
{"value":"1149","il_id":"36","label":"ARPAÇAY"},
{"value":"1279","il_id":"36","label":"DİGOR"},
{"value":"1424","il_id":"36","label":"KAĞIZMAN"},
{"value":"1447","il_id":"36","label":"MERKEZ"},
{"value":"1601","il_id":"36","label":"SARIKAMIŞ"},
{"value":"1614","il_id":"36","label":"SELİM"},
{"value":"1645","il_id":"36","label":"SUSUZ"},
{"value":"1101","il_id":"37","label":"ABANA"},
{"value":"1867","il_id":"37","label":"AĞLI"},
{"value":"1140","il_id":"37","label":"ARAÇ"},
{"value":"1162","il_id":"37","label":"AZDAVAY"},
{"value":"1208","il_id":"37","label":"BOZKURT"},
{"value":"1221","il_id":"37","label":"CİDE"},
{"value":"1238","il_id":"37","label":"ÇATALZEYTİN"},
{"value":"1264","il_id":"37","label":"DADAY"},
{"value":"1277","il_id":"37","label":"DEVREKANİ"},
{"value":"1915","il_id":"37","label":"DOĞANYURT"},
{"value":"1940","il_id":"37","label":"HANÖNÜ"},
{"value":"1805","il_id":"37","label":"İHSANGAZİ"},
{"value":"1410","il_id":"37","label":"İNEBOLU"},
{"value":"1499","il_id":"37","label":"KÜRE"},
{"value":"1450","il_id":"37","label":"MERKEZ"},
{"value":"1836","il_id":"37","label":"PINARBAŞI"},
{"value":"1984","il_id":"37","label":"SEYDİLER"},
{"value":"1845","il_id":"37","label":"ŞENPAZAR"},
{"value":"1666","il_id":"37","label":"TAŞKÖPRÜ"},
{"value":"1685","il_id":"37","label":"TOSYA"},
{"value":"1752","il_id":"38","label":"AKKIŞLA"},
{"value":"1218","il_id":"38","label":"BÜNYAN"},
{"value":"1275","il_id":"38","label":"DEVELİ"},
{"value":"1330","il_id":"38","label":"FELAHİYE"},
{"value":"1936","il_id":"38","label":"HACILAR"},
{"value":"1409","il_id":"38","label":"İNCESU"},
{"value":"1863","il_id":"38","label":"KOCASİNAN"},
{"value":"1864","il_id":"38","label":"MELİKGAZİ"},
{"value":"1978","il_id":"38","label":"ÖZVATAN"},
{"value":"1576","il_id":"38","label":"PINARBAŞI"},
{"value":"1603","il_id":"38","label":"SARIOĞLAN"},
{"value":"1605","il_id":"38","label":"SARIZ"},
{"value":"1846","il_id":"38","label":"TALAS"},
{"value":"1680","il_id":"38","label":"TOMARZA"},
{"value":"1715","il_id":"38","label":"YAHYALI"},
{"value":"1727","il_id":"38","label":"YEŞİLHİSAR"},
{"value":"1163","il_id":"39","label":"BABAESKİ"},
{"value":"1270","il_id":"39","label":"DEMİRKÖY"},
{"value":"1480","il_id":"39","label":"KOFÇAZ"},
{"value":"1505","il_id":"39","label":"LÜLEBURGAZ"},
{"value":"1471","il_id":"39","label":"MERKEZ"},
{"value":"1572","il_id":"39","label":"PEHLİVANKÖY"},
{"value":"1577","il_id":"39","label":"PINARHİSAR"},
{"value":"1714","il_id":"39","label":"VİZE"},
{"value":"1869","il_id":"40","label":"AKÇAKENT"},
{"value":"1754","il_id":"40","label":"AKPINAR"},
{"value":"1890","il_id":"40","label":"BOZTEPE"},
{"value":"1254","il_id":"40","label":"ÇİÇEKDAĞI"},
{"value":"1429","il_id":"40","label":"KAMAN"},
{"value":"1472","il_id":"40","label":"MERKEZ"},
{"value":"1529","il_id":"40","label":"MUCUR"},
{"value":"2058","il_id":"41","label":"BAŞİSKELE"},
{"value":"2059","il_id":"41","label":"ÇAYIROVA"},
{"value":"2060","il_id":"41","label":"DARICA"},
{"value":"2030","il_id":"41","label":"DERİNCE"},
{"value":"2061","il_id":"41","label":"DİLOVASI"},
{"value":"1338","il_id":"41","label":"GEBZE"},
{"value":"1355","il_id":"41","label":"GÖLCÜK"},
{"value":"2062","il_id":"41","label":"İZMİT"},
{"value":"1430","il_id":"41","label":"KANDIRA"},
{"value":"1440","il_id":"41","label":"KARAMÜRSEL"},
{"value":"2063","il_id":"41","label":"KARTEPE"},
{"value":"1821","il_id":"41","label":"KÖRFEZ"},
{"value":"1868","il_id":"42","label":"AHIRLI"},
{"value":"1753","il_id":"42","label":"AKÖREN"},
{"value":"1122","il_id":"42","label":"AKŞEHİR"},
{"value":"1760","il_id":"42","label":"ALTINEKİN"},
{"value":"1188","il_id":"42","label":"BEYŞEHİR"},
{"value":"1207","il_id":"42","label":"BOZKIR"},
{"value":"1222","il_id":"42","label":"CİHANBEYLİ"},
{"value":"1902","il_id":"42","label":"ÇELTİK"},
{"value":"1262","il_id":"42","label":"ÇUMRA"},
{"value":"1907","il_id":"42","label":"DERBENT"},
{"value":"1789","il_id":"42","label":"DEREBUCAK"},
{"value":"1285","il_id":"42","label":"DOĞANHİSAR"},
{"value":"1920","il_id":"42","label":"EMİRGAZİ"},
{"value":"1312","il_id":"42","label":"EREĞLİ"},
{"value":"1933","il_id":"42","label":"GÜNEYSINIR"},
{"value":"1375","il_id":"42","label":"HADİM"},
{"value":"1937","il_id":"42","label":"HALKAPINAR"},
{"value":"1804","il_id":"42","label":"HÜYÜK"},
{"value":"1400","il_id":"42","label":"ILGIN"},
{"value":"1422","il_id":"42","label":"KADINHANI"},
{"value":"1441","il_id":"42","label":"KARAPINAR"},
{"value":"1814","il_id":"42","label":"KARATAY"},
{"value":"1491","il_id":"42","label":"KULU"},
{"value":"1827","il_id":"42","label":"MERAM"},
{"value":"1598","il_id":"42","label":"SARAYÖNÜ"},
{"value":"1839","il_id":"42","label":"SELÇUKLU"},
{"value":"1617","il_id":"42","label":"SEYDİŞEHİR"},
{"value":"1848","il_id":"42","label":"TAŞKENT"},
{"value":"1990","il_id":"42","label":"TUZLUKÇU"},
{"value":"1994","il_id":"42","label":"YALIHÜYÜK"},
{"value":"1735","il_id":"42","label":"YUNAK"},
{"value":"1132","il_id":"43","label":"ALTINTAŞ"},
{"value":"1764","il_id":"43","label":"ASLANAPA"},
{"value":"1898","il_id":"43","label":"ÇAVDARHİSAR"},
{"value":"1288","il_id":"43","label":"DOMANİÇ"},
{"value":"1790","il_id":"43","label":"DUMLUPINAR"},
{"value":"1304","il_id":"43","label":"EMET"},
{"value":"1339","il_id":"43","label":"GEDİZ"},
{"value":"1802","il_id":"43","label":"HİSARCIK"},
{"value":"1500","il_id":"43","label":"MERKEZ"},
{"value":"1979","il_id":"43","label":"PAZARLAR"},
{"value":"1625","il_id":"43","label":"SİMAV"},
{"value":"1843","il_id":"43","label":"ŞAPHANE"},
{"value":"1671","il_id":"43","label":"TAVŞANLI"},
{"value":"1114","il_id":"44","label":"AKÇADAĞ"},
{"value":"1143","il_id":"44","label":"ARAPGİR"},
{"value":"1148","il_id":"44","label":"ARGUVAN"},
{"value":"1772","il_id":"44","label":"BATTALGAZİ"},
{"value":"1265","il_id":"44","label":"DARENDE"},
{"value":"1286","il_id":"44","label":"DOĞANŞEHİR"},
{"value":"1914","il_id":"44","label":"DOĞANYOL"},
{"value":"1390","il_id":"44","label":"HEKİMHAN"},
{"value":"1953","il_id":"44","label":"KALE"},
{"value":"1969","il_id":"44","label":"KULUNCAK"},
{"value":"1582","il_id":"44","label":"PÜTÜRGE"},
{"value":"1995","il_id":"44","label":"YAZIHAN"},
{"value":"1729","il_id":"44","label":"YEŞİLYURT"},
{"value":"1751","il_id":"45","label":"AHMETLİ"},
{"value":"1118","il_id":"45","label":"AKHİSAR"},
{"value":"1127","il_id":"45","label":"ALAŞEHİR"},
{"value":"1269","il_id":"45","label":"DEMİRCİ"},
{"value":"1793","il_id":"45","label":"GÖLMARMARA"},
{"value":"1362","il_id":"45","label":"GÖRDES"},
{"value":"1470","il_id":"45","label":"KIRKAĞAÇ"},
{"value":"1965","il_id":"45","label":"KÖPRÜBAŞI"},
{"value":"1489","il_id":"45","label":"KULA"},
{"value":"1590","il_id":"45","label":"SALİHLİ"},
{"value":"1600","il_id":"45","label":"SARIGÖL"},
{"value":"1606","il_id":"45","label":"SARUHANLI"},
{"value":"1613","il_id":"45","label":"SELENDİ"},
{"value":"1634","il_id":"45","label":"SOMA"},
{"value":"2086","il_id":"45","label":"ŞEHZADELER"},
{"value":"1689","il_id":"45","label":"TURGUTLU"},
{"value":"2087","il_id":"45","label":"YUNUSEMRE"},
{"value":"1107","il_id":"46","label":"AFŞİN"},
{"value":"1136","il_id":"46","label":"ANDIRIN"},
{"value":"1785","il_id":"46","label":"ÇAĞLAYANCERİT"},
{"value":"2084","il_id":"46","label":"DULKADİROĞLU"},
{"value":"1919","il_id":"46","label":"EKİNÖZÜ"},
{"value":"1299","il_id":"46","label":"ELBİSTAN"},
{"value":"1353","il_id":"46","label":"GÖKSUN"},
{"value":"1975","il_id":"46","label":"NURHAK"},
{"value":"2085","il_id":"46","label":"ONİKİŞUBAT"},
{"value":"1570","il_id":"46","label":"PAZARCIK"},
{"value":"1694","il_id":"46","label":"TÜRKOĞLU"},
{"value":"2088","il_id":"47","label":"ARTUKLU"},
{"value":"1787","il_id":"47","label":"DARGEÇİT"},
{"value":"1273","il_id":"47","label":"DERİK"},
{"value":"1474","il_id":"47","label":"KIZILTEPE"},
{"value":"1519","il_id":"47","label":"MAZIDAĞI"},
{"value":"1526","il_id":"47","label":"MİDYAT"},
{"value":"1547","il_id":"47","label":"NUSAYBİN"},
{"value":"1564","il_id":"47","label":"ÖMERLİ"},
{"value":"1609","il_id":"47","label":"SAVUR"},
{"value":"2002","il_id":"47","label":"YEŞİLLİ"},
{"value":"1197","il_id":"48","label":"BODRUM"},
{"value":"1742","il_id":"48","label":"DALAMAN"},
{"value":"1266","il_id":"48","label":"DATÇA"},
{"value":"1331","il_id":"48","label":"FETHİYE"},
{"value":"1958","il_id":"48","label":"KAVAKLIDERE"},
{"value":"1488","il_id":"48","label":"KÖYCEĞİZ"},
{"value":"1517","il_id":"48","label":"MARMARİS"},
{"value":"2089","il_id":"48","label":"MENTEŞE"},
{"value":"1528","il_id":"48","label":"MİLAS"},
{"value":"1831","il_id":"48","label":"ORTACA"},
{"value":"2090","il_id":"48","label":"SEYDİKEMER"},
{"value":"1695","il_id":"48","label":"ULA"},
{"value":"1719","il_id":"48","label":"YATAĞAN"},
{"value":"1213","il_id":"49","label":"BULANIK"},
{"value":"1801","il_id":"49","label":"HASKÖY"},
{"value":"1964","il_id":"49","label":"KORKUT"},
{"value":"1510","il_id":"49","label":"MALAZGİRT"},
{"value":"1534","il_id":"49","label":"MERKEZ"},
{"value":"1711","il_id":"49","label":"VARTO"},
{"value":"1749","il_id":"50","label":"ACIGÖL"},
{"value":"1155","il_id":"50","label":"AVANOS"},
{"value":"1274","il_id":"50","label":"DERİNKUYU"},
{"value":"1367","il_id":"50","label":"GÜLŞEHİR"},
{"value":"1374","il_id":"50","label":"HACIBEKTAŞ"},
{"value":"1485","il_id":"50","label":"KOZAKLI"},
{"value":"1543","il_id":"50","label":"MERKEZ"},
{"value":"1707","il_id":"50","label":"ÜRGÜP"},
{"value":"1876","il_id":"51","label":"ALTUNHİSAR"},
{"value":"1201","il_id":"51","label":"BOR"},
{"value":"1225","il_id":"51","label":"ÇAMARDI"},
{"value":"1904","il_id":"51","label":"ÇİFTLİK"},
{"value":"1544","il_id":"51","label":"MERKEZ"},
{"value":"1700","il_id":"51","label":"ULUKIŞLA"},
{"value":"1119","il_id":"52","label":"AKKUŞ"},
{"value":"2103","il_id":"52","label":"ALTINORDU"},
{"value":"1158","il_id":"52","label":"AYBASTI"},
{"value":"1891","il_id":"52","label":"ÇAMAŞ"},
{"value":"1897","il_id":"52","label":"ÇATALPINAR"},
{"value":"1900","il_id":"52","label":"ÇAYBAŞI"},
{"value":"1328","il_id":"52","label":"FATSA"},
{"value":"1358","il_id":"52","label":"GÖLKÖY"},
{"value":"1795","il_id":"52","label":"GÜLYALI"},
{"value":"1797","il_id":"52","label":"GÜRGENTEPE"},
{"value":"1947","il_id":"52","label":"İKİZCE"},
{"value":"1950","il_id":"52","label":"KABADÜZ"},
{"value":"1951","il_id":"52","label":"KABATAŞ"},
{"value":"1482","il_id":"52","label":"KORGAN"},
{"value":"1493","il_id":"52","label":"KUMRU"},
{"value":"1525","il_id":"52","label":"MESUDİYE"},
{"value":"1573","il_id":"52","label":"PERŞEMBE"},
{"value":"1696","il_id":"52","label":"ULUBEY"},
{"value":"1706","il_id":"52","label":"ÜNYE"},
{"value":"1146","il_id":"53","label":"ARDEŞEN"},
{"value":"1228","il_id":"53","label":"ÇAMLIHEMŞİN"},
{"value":"1241","il_id":"53","label":"ÇAYELİ"},
{"value":"1908","il_id":"53","label":"DEREPAZARI"},
{"value":"1332","il_id":"53","label":"FINDIKLI"},
{"value":"1796","il_id":"53","label":"GÜNEYSU"},
{"value":"1943","il_id":"53","label":"HEMŞİN"},
{"value":"1405","il_id":"53","label":"İKİZDERE"},
{"value":"1949","il_id":"53","label":"İYİDERE"},
{"value":"1428","il_id":"53","label":"KALKANDERE"},
{"value":"1586","il_id":"53","label":"MERKEZ"},
{"value":"1569","il_id":"53","label":"PAZAR"},
{"value":"2068","il_id":"54","label":"ADAPAZARI"},
{"value":"1123","il_id":"54","label":"AKYAZI"},
{"value":"2069","il_id":"54","label":"ARİFİYE"},
{"value":"2070","il_id":"54","label":"ERENLER"},
{"value":"1925","il_id":"54","label":"FERİZLİ"},
{"value":"1351","il_id":"54","label":"GEYVE"},
{"value":"1391","il_id":"54","label":"HENDEK"},
{"value":"1955","il_id":"54","label":"KARAPÜRÇEK"},
{"value":"1442","il_id":"54","label":"KARASU"},
{"value":"1453","il_id":"54","label":"KAYNARCA"},
{"value":"1818","il_id":"54","label":"KOCAALİ"},
{"value":"1833","il_id":"54","label":"PAMUKOVA"},
{"value":"1595","il_id":"54","label":"SAPANCA"},
{"value":"2071","il_id":"54","label":"SERDİVAN"},
{"value":"1986","il_id":"54","label":"SÖĞÜTLÜ"},
{"value":"1847","il_id":"54","label":"TARAKLI"},
{"value":"1125","il_id":"55","label":"ALAÇAM"},
{"value":"1763","il_id":"55","label":"ASARCIK"},
{"value":"2072","il_id":"55","label":"ATAKUM"},
{"value":"1879","il_id":"55","label":"AYVACIK"},
{"value":"1164","il_id":"55","label":"BAFRA"},
{"value":"2073","il_id":"55","label":"CANİK"},
{"value":"1234","il_id":"55","label":"ÇARŞAMBA"},
{"value":"1386","il_id":"55","label":"HAVZA"},
{"value":"2074","il_id":"55","label":"İLKADIM"},
{"value":"1452","il_id":"55","label":"KAVAK"},
{"value":"1501","il_id":"55","label":"LADİK"},
{"value":"1838","il_id":"55","label":"SALIPAZARI"},
{"value":"1849","il_id":"55","label":"TEKKEKÖY"},
{"value":"1676","il_id":"55","label":"TERME"},
{"value":"1712","il_id":"55","label":"VEZİRKÖPRÜ"},
{"value":"1993","il_id":"55","label":"YAKAKENT"},
{"value":"1830","il_id":"55","label":"19 MAYIS"},
{"value":"1179","il_id":"56","label":"BAYKAN"},
{"value":"1317","il_id":"56","label":"ERUH"},
{"value":"1495","il_id":"56","label":"KURTALAN"},
{"value":"1620","il_id":"56","label":"MERKEZ"},
{"value":"1575","il_id":"56","label":"PERVARİ"},
{"value":"1662","il_id":"56","label":"ŞİRVAN"},
{"value":"1878","il_id":"56","label":"TİLLO"},
{"value":"1156","il_id":"57","label":"AYANCIK"},
{"value":"1204","il_id":"57","label":"BOYABAT"},
{"value":"1910","il_id":"57","label":"DİKMEN"},
{"value":"1290","il_id":"57","label":"DURAĞAN"},
{"value":"1314","il_id":"57","label":"ERFELEK"},
{"value":"1349","il_id":"57","label":"GERZE"},
{"value":"1627","il_id":"57","label":"MERKEZ"},
{"value":"1981","il_id":"57","label":"SARAYDÜZÜ"},
{"value":"1693","il_id":"57","label":"TÜRKELİ"},
{"value":"1870","il_id":"58","label":"AKINCILAR"},
{"value":"1875","il_id":"58","label":"ALTINYAYLA"},
{"value":"1282","il_id":"58","label":"DİVRİĞİ"},
{"value":"1913","il_id":"58","label":"DOĞANŞAR"},
{"value":"1342","il_id":"58","label":"GEMEREK"},
{"value":"1927","il_id":"58","label":"GÖLOVA"},
{"value":"1373","il_id":"58","label":"GÜRÜN"},
{"value":"1376","il_id":"58","label":"HAFİK"},
{"value":"1407","il_id":"58","label":"İMRANLI"},
{"value":"1431","il_id":"58","label":"KANGAL"},
{"value":"1484","il_id":"58","label":"KOYULHİSAR"},
{"value":"1628","il_id":"58","label":"MERKEZ"},
{"value":"1646","il_id":"58","label":"SUŞEHRİ"},
{"value":"1650","il_id":"58","label":"ŞARKIŞLA"},
{"value":"1991","il_id":"58","label":"ULAŞ"},
{"value":"1731","il_id":"58","label":"YILDIZELİ"},
{"value":"1738","il_id":"58","label":"ZARA"},
{"value":"1250","il_id":"59","label":"ÇERKEZKÖY"},
{"value":"1258","il_id":"59","label":"ÇORLU"},
{"value":"2094","il_id":"59","label":"ERGENE"},
{"value":"1388","il_id":"59","label":"HAYRABOLU"},
{"value":"2095","il_id":"59","label":"KAPAKLI"},
{"value":"1511","il_id":"59","label":"MALKARA"},
{"value":"1825","il_id":"59","label":"MARMARAEREĞLİSİ"},
{"value":"1538","il_id":"59","label":"MURATLI"},
{"value":"1596","il_id":"59","label":"SARAY"},
{"value":"2096","il_id":"59","label":"SÜLEYMANPAŞA"},
{"value":"1652","il_id":"59","label":"ŞARKÖY"},
{"value":"1129","il_id":"60","label":"ALMUS"},
{"value":"1151","il_id":"60","label":"ARTOVA"},
{"value":"1883","il_id":"60","label":"BAŞÇİFTLİK"},
{"value":"1308","il_id":"60","label":"ERBAA"},
{"value":"1679","il_id":"60","label":"MERKEZ"},
{"value":"1545","il_id":"60","label":"NİKSAR"},
{"value":"1834","il_id":"60","label":"PAZAR"},
{"value":"1584","il_id":"60","label":"REŞADİYE"},
{"value":"1987","il_id":"60","label":"SULUSARAY"},
{"value":"1690","il_id":"60","label":"TURHAL"},
{"value":"1858","il_id":"60","label":"YEŞİLYURT"},
{"value":"1740","il_id":"60","label":"ZİLE"},
{"value":"1113","il_id":"61","label":"AKÇAABAT"},
{"value":"1141","il_id":"61","label":"ARAKLI"},
{"value":"1150","il_id":"61","label":"ARSİN"},
{"value":"1775","il_id":"61","label":"BEŞİKDÜZÜ"},
{"value":"1896","il_id":"61","label":"ÇARŞIBAŞI"},
{"value":"1244","il_id":"61","label":"ÇAYKARA"},
{"value":"1909","il_id":"61","label":"DERNEKPAZARI"},
{"value":"1917","il_id":"61","label":"DÜZKÖY"},
{"value":"1942","il_id":"61","label":"HAYRAT"},
{"value":"1966","il_id":"61","label":"KÖPRÜBAŞI"},
{"value":"1507","il_id":"61","label":"MAÇKA"},
{"value":"1548","il_id":"61","label":"OF"},
{"value":"2097","il_id":"61","label":"ORTAHİSAR"},
{"value":"1647","il_id":"61","label":"SÜRMENE"},
{"value":"1842","il_id":"61","label":"ŞALPAZARI"},
{"value":"1681","il_id":"61","label":"TONYA"},
{"value":"1709","il_id":"61","label":"VAKFIKEBİR"},
{"value":"1732","il_id":"61","label":"YOMRA"},
{"value":"1247","il_id":"62","label":"ÇEMİŞGEZEK"},
{"value":"1397","il_id":"62","label":"HOZAT"},
{"value":"1518","il_id":"62","label":"MAZGİRT"},
{"value":"1688","il_id":"62","label":"MERKEZ"},
{"value":"1541","il_id":"62","label":"NAZIMİYE"},
{"value":"1562","il_id":"62","label":"OVACIK"},
{"value":"1574","il_id":"62","label":"PERTEK"},
{"value":"1581","il_id":"62","label":"PÜLÜMÜR"},
{"value":"1115","il_id":"63","label":"AKÇAKALE"},
{"value":"1194","il_id":"63","label":"BİRECİK"},
{"value":"1209","il_id":"63","label":"BOZOVA"},
{"value":"1220","il_id":"63","label":"CEYLANPINAR"},
{"value":"2091","il_id":"63","label":"EYYÜBİYE"},
{"value":"1378","il_id":"63","label":"HALFETİ"},
{"value":"2092","il_id":"63","label":"HALİLİYE"},
{"value":"1800","il_id":"63","label":"HARRAN"},
{"value":"1393","il_id":"63","label":"HİLVAN"},
{"value":"2093","il_id":"63","label":"KARAKÖPRÜ"},
{"value":"1630","il_id":"63","label":"SİVEREK"},
{"value":"1643","il_id":"63","label":"SURUÇ"},
{"value":"1713","il_id":"63","label":"VİRANŞEHİR"},
{"value":"1170","il_id":"64","label":"BANAZ"},
{"value":"1323","il_id":"64","label":"EŞME"},
{"value":"1436","il_id":"64","label":"KARAHALLI"},
{"value":"1704","il_id":"64","label":"MERKEZ"},
{"value":"1629","il_id":"64","label":"SİVASLI"},
{"value":"1697","il_id":"64","label":"ULUBEY"},
{"value":"1770","il_id":"65","label":"BAHÇESARAY"},
{"value":"1175","il_id":"65","label":"BAŞKALE"},
{"value":"1786","il_id":"65","label":"ÇALDIRAN"},
{"value":"1236","il_id":"65","label":"ÇATAK"},
{"value":"1918","il_id":"65","label":"EDREMİT"},
{"value":"1309","il_id":"65","label":"ERCİŞ"},
{"value":"1350","il_id":"65","label":"GEVAŞ"},
{"value":"1372","il_id":"65","label":"GÜRPINAR"},
{"value":"2098","il_id":"65","label":"İPEKYOLU"},
{"value":"1533","il_id":"65","label":"MURADİYE"},
{"value":"1565","il_id":"65","label":"ÖZALP"},
{"value":"1980","il_id":"65","label":"SARAY"},
{"value":"2099","il_id":"65","label":"TUŞBA"},
{"value":"1117","il_id":"66","label":"AKDAĞMADENİ"},
{"value":"1877","il_id":"66","label":"AYDINCIK"},
{"value":"1198","il_id":"66","label":"BOĞAZLIYAN"},
{"value":"1895","il_id":"66","label":"ÇANDIR"},
{"value":"1242","il_id":"66","label":"ÇAYIRALAN"},
{"value":"1245","il_id":"66","label":"ÇEKEREK"},
{"value":"1952","il_id":"66","label":"KADIŞEHRİ"},
{"value":"1733","il_id":"66","label":"MERKEZ"},
{"value":"1982","il_id":"66","label":"SARAYKENT"},
{"value":"1602","il_id":"66","label":"SARIKAYA"},
{"value":"1635","il_id":"66","label":"SORGUN"},
{"value":"1655","il_id":"66","label":"ŞEFAATLİ"},
{"value":"1998","il_id":"66","label":"YENİFAKILI"},
{"value":"1726","il_id":"66","label":"YERKÖY"},
{"value":"1758","il_id":"67","label":"ALAPLI"},
{"value":"1240","il_id":"67","label":"ÇAYCUMA"},
{"value":"1276","il_id":"67","label":"DEVREK"},
{"value":"1313","il_id":"67","label":"EREĞLİ"},
{"value":"1926","il_id":"67","label":"GÖKÇEBEY"},
{"value":"2100","il_id":"67","label":"KİLİMLİ"},
{"value":"2101","il_id":"67","label":"KOZLU"},
{"value":"1741","il_id":"67","label":"MERKEZ"},
{"value":"1860","il_id":"68","label":"AĞAÇÖREN"},
{"value":"1921","il_id":"68","label":"ESKİL"},
{"value":"1932","il_id":"68","label":"GÜLAĞAÇ"},
{"value":"1861","il_id":"68","label":"GÜZELYURT"},
{"value":"1120","il_id":"68","label":"MERKEZ"},
{"value":"1557","il_id":"68","label":"ORTAKÖY"},
{"value":"1866","il_id":"68","label":"SARIYAHŞİ"},
{"value":"2106","il_id":"68","label":"SULTANHANI"},
{"value":"1767","il_id":"69","label":"AYDINTEPE"},
{"value":"1788","il_id":"69","label":"DEMİRÖZÜ"},
{"value":"1176","il_id":"69","label":"MERKEZ"},
{"value":"1768","il_id":"70","label":"AYRANCI"},
{"value":"1884","il_id":"70","label":"BAŞYAYLA"},
{"value":"1316","il_id":"70","label":"ERMENEK"},
{"value":"1862","il_id":"70","label":"KAZIMKARABEKİR"},
{"value":"1439","il_id":"70","label":"MERKEZ"},
{"value":"1983","il_id":"70","label":"SARIVELİLER"},
{"value":"1880","il_id":"71","label":"BAHŞİLİ"},
{"value":"1882","il_id":"71","label":"BALIŞEYH"},
{"value":"1901","il_id":"71","label":"ÇELEBİ"},
{"value":"1268","il_id":"71","label":"DELİCE"},
{"value":"1954","il_id":"71","label":"KARAKEÇİLİ"},
{"value":"1463","il_id":"71","label":"KESKİN"},
{"value":"1469","il_id":"71","label":"MERKEZ"},
{"value":"1638","il_id":"71","label":"SULAKYURT"},
{"value":"1992","il_id":"71","label":"YAHŞİHAN"},
{"value":"1184","il_id":"72","label":"BEŞİRİ"},
{"value":"1345","il_id":"72","label":"GERCÜŞ"},
{"value":"1941","il_id":"72","label":"HASANKEYF"},
{"value":"1487","il_id":"72","label":"KOZLUK"},
{"value":"1174","il_id":"72","label":"MERKEZ"},
{"value":"1607","il_id":"72","label":"SASON"},
{"value":"1189","il_id":"73","label":"BEYTÜŞŞEBAP"},
{"value":"1223","il_id":"73","label":"CİZRE"},
{"value":"1931","il_id":"73","label":"GÜÇLÜKONAK"},
{"value":"1403","il_id":"73","label":"İDİL"},
{"value":"1661","il_id":"73","label":"MERKEZ"},
{"value":"1623","il_id":"73","label":"SİLOPİ"},
{"value":"1698","il_id":"73","label":"ULUDERE"},
{"value":"1761","il_id":"74","label":"AMASRA"},
{"value":"1496","il_id":"74","label":"KURUCAŞİLE"},
{"value":"1172","il_id":"74","label":"MERKEZ"},
{"value":"1701","il_id":"74","label":"ULUS"},
{"value":"1252","il_id":"75","label":"ÇILDIR"},
{"value":"2008","il_id":"75","label":"DAMAL"},
{"value":"1356","il_id":"75","label":"GÖLE"},
{"value":"1380","il_id":"75","label":"HANAK"},
{"value":"1144","il_id":"75","label":"MERKEZ"},
{"value":"1579","il_id":"75","label":"POSOF"},
{"value":"1142","il_id":"76","label":"ARALIK"},
{"value":"2011","il_id":"76","label":"KARAKOYUNLU"},
{"value":"1398","il_id":"76","label":"MERKEZ"},
{"value":"1692","il_id":"76","label":"TUZLUCA"},
{"value":"2019","il_id":"77","label":"ALTINOVA"},
{"value":"2020","il_id":"77","label":"ARMUTLU"},
{"value":"2021","il_id":"77","label":"ÇINARCIK"},
{"value":"2022","il_id":"77","label":"ÇİFTLİKKÖY"},
{"value":"1716","il_id":"77","label":"MERKEZ"},
{"value":"2026","il_id":"77","label":"TERMAL"},
{"value":"1296","il_id":"78","label":"EFLANİ"},
{"value":"1321","il_id":"78","label":"ESKİPAZAR"},
{"value":"1433","il_id":"78","label":"MERKEZ"},
{"value":"1561","il_id":"78","label":"OVACIK"},
{"value":"1587","il_id":"78","label":"SAFRANBOLU"},
{"value":"1856","il_id":"78","label":"YENİCE"},
{"value":"2023","il_id":"79","label":"ELBEYLİ"},
{"value":"1476","il_id":"79","label":"MERKEZ"},
{"value":"2024","il_id":"79","label":"MUSABEYLİ"},
{"value":"2025","il_id":"79","label":"POLATELİ"},
{"value":"1165","il_id":"80","label":"BAHÇE"},
{"value":"1743","il_id":"80","label":"DÜZİÇİ"},
{"value":"2027","il_id":"80","label":"HASANBEYLİ"},
{"value":"1423","il_id":"80","label":"KADİRLİ"},
{"value":"1560","il_id":"80","label":"MERKEZ"},
{"value":"2028","il_id":"80","label":"SUMBAS"},
{"value":"2029","il_id":"80","label":"TOPRAKKALE"},
{"value":"1116","il_id":"81","label":"AKÇAKOCA"},
{"value":"1784","il_id":"81","label":"CUMAYERİ"},
{"value":"1905","il_id":"81","label":"ÇİLİMLİ"},
{"value":"1794","il_id":"81","label":"GÖLYAKA"},
{"value":"2017","il_id":"81","label":"GÜMÜŞOVA"},
{"value":"2031","il_id":"81","label":"KAYNAŞLI"},
{"value":"1292","il_id":"81","label":"MERKEZ"},
{"value":"1730","il_id":"81","label":"YIĞILCA"}
  ]);

  const [selectedIl, setSelectedIl] = useState('');
     const [selectedIlLabel, setSelectedIlLabel] = useState('');
     const [selectedIlce, setSelectedIlce] = useState('');
          const [selectedIlceLabel, setSelectedIlceLabel] = useState('');

  const [filteredIlceler, setFilteredIlceler] = useState([]);


  // İl seçimi yapıldığında ilçeleri filtreleyen fonksiyon

  const handleIlChange = (event) => {
    const selectedIlId = event.value;
    setSelectedIl(selectedIlId);
 const il = ills.find(il => il.value === selectedIlId);

    setCity(il.label);
    setSelectedIlLabel(il.label);
    const filtered = ilceler.filter(ilce => ilce.il_id === selectedIlId);
    setFilteredIlceler(filtered);
  };

  const handleIlceChange = (event) => {
    const selectedIlceId = event.value;
    setSelectedIlce(selectedIlceId);
     const ilce = ilceler.find(ilce => ilce.value === selectedIlceId);

    setDistrict(ilce.label);
    setSelectedIlceLabel(ilce.label);

  }

return (
    <>
        <div className="input-group">

            <Select

                defaultValue={selectedIlLabel}
                label="İl"
                onChange={(e) => {
                    handleIlChange(e)
                }}
                fullWidth={true}
                options={ills}
                placeholder={'İl Seçiniz'}
                style={{marginBottom: '10px', marginTop: '10px'}}
                filterOption={customFilter}

            >

            </Select>

        </div>
        <div className="input-group">

            <Select
                defaultValue={selectedIlceLabel}
                label="İlçe"
                onChange={(e) => {
                    handleIlceChange(e)
                }}
                fullWidth={true}
                options={filteredIlceler}
                placeholder={'İlçe Seçiniz'}
                style={{marginBottom: '10px', marginTop: '10px'}}

            >

            </Select>
        </div>
    </>
);
}


export default LocationSelectForMain;
